import {toast} from "react-toastify";
import axios from "axios";
import {
    initClientPaymentsReport,
    initSalesBalanceSheet,
    initSalesGraphicReport, initSalesMonthlyTurnoverReport, setEditQuotations,
    setEditSales
} from "../_reducers/DataPanel/Sales/salesSlice";
import {addTab, updateActiveMainTab} from "../_reducers/TabsSlice";
import {
    initBuysBalanceReport,
    initBuysGraphicReport, initBuysMonthlyTurnoverReport,
    initSupplierPaymentReport,
    setEditBuys
} from "../_reducers/DataPanel/Buys/buysSlice";
import {
    initAccountsReport,
    initCalendarReport, initGeneralCalendarReport, initIEBookReport,
    initIsozygioReport,
    setEditAccountingAccount,
    setEditAccountingRecord,
    setEditEmployee,
    setSelectedSubmittedVatDeclaration,
    setSelectedSubmittedF4Declaration, setSelectedSubmittedF5Declaration, setSelectedUnregulatedDebt
} from "../_reducers/DataPanel/Accounting/accountingSlice";
import {
    initClientBalanceReport, initClientIsozygioReport, initClientMovementsReport,
    setEditClient,
    setEditClientMovements,
    setEditClientPayment
} from "../_reducers/DataPanel/Clients/clientSlice";
import {
    initSupplierBalanceReport, initSupplierIsozygioReport, initSupplierMovementsReport,
    setEditSupplier,
    setEditSupplierMovements,
    setEditSupplierPayment
} from "../_reducers/DataPanel/Suppliers/supplierSlice";
import {
    initFixedAssetBookReport,
    initFixedAssetMovementsReport, initFixedAssetSoldReport,
    setEditFixedAsset,
    setEditFixedAssetMovement,
    setEditFixedAssetRecord
} from "../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import {
    initProductBalanceReport, initProductMovementsReport,
    setEditPriceList,
    setEditProductMovements,
    setSelectedEditProduct
} from "../_reducers/DataPanel/Products/productsSlice";
import {setEditDcl} from "../_reducers/DataPanel/Dcl/dclSlice";
import {setEditWorkMovement, setEditWorkPermit} from "../_reducers/DataPanel/Payroll/payrollSlice";
import {
    setEditBankAccount, setEditCard,
    setEditCashRegisters,
    setEditCheque, setEditLoan,
    setEditPOS
} from "../_reducers/DataPanel/Cash/cashSlice";
import {setEditAdvancedType, setEditBasicType} from "../_reducers/settingsSlice";
import {setEditVisit, setEditVisitReload} from "../_reducers/DataPanel/Prescription/prescriptionSlice";
import {setRememberInnerTab} from "../_reducers/activitySlice";

const multipleTabTypes = [
    // Products
    "edit-product",
    "product-balancesheet-reports",
    "product-movments-reports",

    // Sales
    "view-sales",
    "sales-balance-sheet",
    "client-payments-report",
    "sales-graphic-report",
    "sales-monthly-turnover",

    // Quotations
    "sales-quotations-edit",

    // Buys
    "buys-balance-sheet",
    "supplier-payments-report",
    "buys-graphic-report",
    "buys-monthly-turnover",

    // Clients
    "edit-client",
    "client-balance",
    "clients-movements",
    "report-client-isozygio",

    // Suppliers
    "edit-supplier",
    "supplier-balance",
    "suppliers-movements",
    "report-supplier-isozygio",

    // Fixed Assets
    "report-fixed-asset-movements",
    "report-fixed-asset-book",
    "report-sold-fixed-assets",

    // Accounting
    "accounting-report-isozygio",
    "accounting-report-calendar",
    "accounting-report-accounts",
    "accounting-report-general-calendar",
    "accounting-ie-book",

    // Vat declarations
    "view-submitted-vat-declaration",
    "view-submitted-f4-declaration",
    "view-submitted-f5-declaration",

    // Debts
    "view-debts"
]

export const CHECK_FOR_ACTIVITY = [
    // Products
    "products-new",
    "edit-product",
    "product-movements-new",
    "edit-product-movements",
    "product-pricelist-new",
    "edit-price-list",

    // Sales
    "sales-new",
    "sales-quotations-new",
    "sales-quotations-edit",
    "primer-ai-url",
    "new-client-payments",
    "sales-general-settings",

    // Buys
    "buys-new",
    "new-supplier-payments",
    "buys-general-settings",

    // Clients
    "new-client",
    "edit-client",
    "new-client-movements",

    // Suppliers
    "new-supplier",
    "new-supplier-movements",

    // Cash
    "cash-registers-new",
    "new-bank-account",
    "new-pos",

    // Accounting
    "accounting-account-new",
    "accounting-record-new",
    "new-accounting-account",

    // Payroll
    "new-employee",

    // Settings
    "basic-types-new",
    "advanced-types-new",

    // Fixed Assets
    "new-fixed-asset",
    "new-fixed-asset-movement",
    "new-fixed-asset-record",
]

export const generateTabKey = () => {
    return String(Date.now());
}

// In some cases you need to initialize data before opening a tab multiple times
export const initMultipleTab = (tabType, tabKey) => {
    return (dispatch) => {
        switch (tabType) {
            case "product-balancesheet-reports":
                dispatch(initProductBalanceReport({tabKey}));
                break;
            case "product-movments-reports":
                dispatch(initProductMovementsReport({tabKey}));
                break;
            case "sales-balance-sheet":
                dispatch(initSalesBalanceSheet({tabKey}));
                break;
            case "client-payments-report":
                dispatch(initClientPaymentsReport({tabKey}));
                break;
            case "buys-balance-sheet":
                dispatch(initBuysBalanceReport({tabKey}));
                break;
            case "supplier-payments-report":
                dispatch(initSupplierPaymentReport({tabKey}));
                break;
            case "sales-graphic-report":
                dispatch(initSalesGraphicReport({tabKey}));
                break;
            case "sales-monthly-turnover":
                dispatch(initSalesMonthlyTurnoverReport({tabKey}));
                break;
            case "buys-graphic-report":
                dispatch(initBuysGraphicReport({tabKey}));
                break;
            case "buys-monthly-turnover":
                dispatch(initBuysMonthlyTurnoverReport({tabKey}));
                break;
            case "client-balance":
                dispatch(initClientBalanceReport({tabKey}));
                break;
            case "clients-movements":
                dispatch(initClientMovementsReport({tabKey}));
                break;
            case "report-client-isozygio":
                dispatch(initClientIsozygioReport({tabKey}));
                break;
            case "supplier-balance":
                dispatch(initSupplierBalanceReport({tabKey}));
                break;
            case "suppliers-movements":
                dispatch(initSupplierMovementsReport({tabKey}));
                break;
            case "report-supplier-isozygio":
                dispatch(initSupplierIsozygioReport({tabKey}));
                break;
            case "report-fixed-asset-movements":
                dispatch(initFixedAssetMovementsReport({tabKey}));
                break;
            case "report-fixed-asset-book":
                dispatch(initFixedAssetBookReport({tabKey}));
                break;
            case "report-sold-fixed-assets":
                dispatch(initFixedAssetSoldReport({tabKey}));
                break;
            case "accounting-report-isozygio":
                dispatch(initIsozygioReport({tabKey}));
                break;
            case "accounting-report-calendar":
                dispatch(initCalendarReport({tabKey}));
                break;
            case "accounting-report-accounts":
                dispatch(initAccountsReport({tabKey}));
                break;
            case "accounting-report-general-calendar":
                dispatch(initGeneralCalendarReport({tabKey}));
                break;
            case "accounting-ie-book":
                dispatch(initIEBookReport({tabKey}));
                break;
            case "view-submitted-vat-declaration":
                break;
            default:
                break;
        }
    }
}

export const addTabIfNotExists = (tabType, tabKey, TABS_DATA, innerTabNavigation = null, displayName = null) => {
    // innerTabNavigation is used when you have multiple tabs inside a tab using the data-panel.
    // Put the tabNumber you want to be auto-selected when opening a multiple-tab page
    return (dispatch) => {
        if (multipleTabTypes.includes(tabType)) {
            const idx = TABS_DATA.findIndex((item) => tabKey === item.key);
            if (idx === -1) {
                dispatch(initMultipleTab(tabType, tabKey));
                dispatch(addTab({
                    tabType,
                    key: tabKey,
                    displayName: displayName ? displayName : "",
                }));
                dispatch(updateActiveMainTab(TABS_DATA.length));
            } else {
                dispatch(updateActiveMainTab(idx));
            }
        } else {
            const idx = TABS_DATA.findIndex((item) => tabType === item.tabType);
            if (idx === -1) {
                dispatch(addTab({
                    tabType: tabType,
                    key: tabKey
                }));
                dispatch(updateActiveMainTab(TABS_DATA.length));
            } else {
                dispatch(updateActiveMainTab(idx));
            }
        }
        if (innerTabNavigation) dispatch(setRememberInnerTab({ [tabKey] : innerTabNavigation }))
    }
}

export const openSale = (dispatch, TABS_DATA, companyId, docId) => {
    axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
        headers: { "Content-Type": "application/json" },
        params: {
            company: companyId,
            docId: docId,
            section: "Sales",
        }
    }).then((res) => {
        if (res.data.status === "200") {
            dispatch(openSaleLocal(res.data.data, TABS_DATA));
        } else {
            toast.error(res.data.message);
        }
    }).catch((err) => {
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση εγγραφής.");
    });
}

export const openSaleLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        const tabKey = `view-sales/${data._id}`;
        const action = setEditSales(data);
        const taggedAction = {
            ...action,
            meta: {
                ...(action.meta || {}),
                tabKey: tabKey,
            }
        }
        dispatch(taggedAction);
        dispatch(addTabIfNotExists("view-sales", tabKey, TABS_DATA));
    }
}

export const openBuy = (dispatch, TABS_DATA, companyId, docId) => {
    try {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: companyId,
                docId: docId,
                section: "Buys",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(openBuyLocal(res.data.data, TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        });
    } catch (err) {
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση εγγραφής.");
    }
}

export const openBuyLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditBuys(data));
        dispatch(addTabIfNotExists("edit-buys", generateTabKey(), TABS_DATA));
    }
}

export const openQuotation = (dispatch, TABS_DATA, companyId, docId) => {
    try {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: companyId,
                docId: docId,
                section: "Quotations",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(openQuotationLocal(res.data.data, TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        });
    } catch (err) {
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση εγγραφής.");
    }
}

export const openQuotationLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        const tabKey = `sales-quotations-edit/${data._id}`;
        const action = setEditQuotations(data);
        const taggedAction = {
            ...action,
            meta: {
                ...(action.meta || {}),
                tabKey: tabKey,
            }
        }
        dispatch(taggedAction);
        dispatch(addTabIfNotExists("sales-quotations-edit", tabKey, TABS_DATA));
    }
}

export const openAccountingRecord = (dispatch, TABS_DATA, companyId, docId) => {
    try {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: companyId,
                docId: docId,
                section: "Accounting Records",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(openAccountingRecordLocal(res.data.data, TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        });
    } catch (err) {
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση εγγραφής.");
    }
}

export const openAccountingRecordLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditAccountingRecord(data));
        dispatch(addTabIfNotExists("accounting-record-edit", generateTabKey(), TABS_DATA));
    }
}

export const openClientPayment = (dispatch, TABS_DATA, companyId, docId) => {
    try {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: companyId,
                docId: docId,
                section: "Client Payments",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(openClientPaymentLocal(res.data.data, TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        });
    } catch (err) {
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση εγγραφής.");
    }
}

export const openClientPaymentLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditClientPayment(data));
        dispatch(addTabIfNotExists("edit-client-payments", generateTabKey(), TABS_DATA));
    }
}

export const openSupplierPayment = (dispatch, TABS_DATA, companyId, docId) => {
    try {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: companyId,
                docId: docId,
                section: "Supplier Payments",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(openSupplierPaymentLocal(res.data.data, TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        });
    } catch (err) {
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση εγγραφής.");
    }
}

export const openSupplierPaymentLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditSupplierPayment(data));
        dispatch(addTabIfNotExists("edit-supplier-payments", generateTabKey(), TABS_DATA));
    }
}

export const openClientMovement = (dispatch, TABS_DATA, companyId, docId) => {
    try {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: companyId,
                docId: docId,
                section: "Client Movements",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(openClientMovementLocal(res.data.data, TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        });
    } catch (err) {
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση εγγραφής.");
    }
}

export const openClientMovementLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditClientMovements(data));
        dispatch(addTabIfNotExists("edit-client-movements", generateTabKey(), TABS_DATA));
    }
}

export const openSupplierMovement = (dispatch, TABS_DATA, companyId, docId) => {
    try {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: companyId,
                docId: docId,
                section: "Supplier Movements",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(openSupplierMovementLocal(res.data.data, TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        });
    } catch (err) {
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση εγγραφής.");
    }
}

export const openSupplierMovementLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditSupplierMovements(data));
        dispatch(addTabIfNotExists("edit-supplier-movements", generateTabKey(), TABS_DATA));
    }
}

export const openFixedAssetMovement = (dispatch, TABS_DATA, companyId, docId) => {
    try {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: companyId,
                docId: docId,
                section: "Fixed Asset Movements",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(openFixedAssetMovementLocal(res.data.data, TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        });
    } catch (err) {
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση εγγραφής.");
    }
}

export const openFixedAssetMovementLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditFixedAssetMovement(data));
        dispatch(addTabIfNotExists("edit-fixed-asset-movement", generateTabKey(), TABS_DATA));
    }
}

export const openFixedAssetRecord = (dispatch, TABS_DATA, companyId, docId) => {
    try {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: companyId,
                docId: docId,
                section: "Fixed Asset Records",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(openFixedAssetRecordLocal(res.data.data, TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        });
    } catch (err) {
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση εγγραφής.");
    }
}

export const openFixedAssetRecordLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditFixedAssetRecord(data));
        dispatch(addTabIfNotExists("edit-fixed-asset-record", generateTabKey(), TABS_DATA));
    }
}

export const openFixedAssetLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditFixedAsset(data));
        dispatch(addTabIfNotExists("edit-fixed-asset", generateTabKey(), TABS_DATA));
    }
}

export const openClient = (dispatch, TABS_DATA, companyId, clientId, innerTabNavigation = null) => {
    try {
        axios.get(process.env.REACT_APP_API_URL2 + `/client/get-client-id-by/${clientId}`, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                dispatch(openClientLocal(res.data.data, TABS_DATA, innerTabNavigation));
            } else {
                toast.error("Σφάλμα κατά την εύρεση πελάτη.");
            }
        }).catch((error) => {
            console.log(error);
            toast.error("Σφάλμα κατά την άντληση πελάτη.");
        })
    } catch (err) {
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση πελάτη.");
    }
}

export const openClientLocal = (data, TABS_DATA, innerTabNavigation) => {
    return (dispatch) => {
        const tabKey = `edit-client/${data._id}`;
        const action = setEditClient(data);
        const taggedAction = {
            ...action,
            meta: {
                ...(action.meta || {}),
                tabKey: tabKey,
            }
        }
        dispatch(taggedAction);
        dispatch(addTabIfNotExists("edit-client", tabKey, TABS_DATA, innerTabNavigation, data.name));
    }
}

export const openSupplierLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        const tabKey = `edit-supplier/${data._id}`;
        const action = setEditSupplier(data);
        const taggedAction = {
            ...action,
            meta: {
                ...(action.meta || {}),
                tabKey: tabKey,
            }
        }
        dispatch(taggedAction);
        dispatch(addTabIfNotExists("edit-supplier", tabKey, TABS_DATA, null, data.name));
    }
}

export const openProductLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        const tabKey = `edit-product/${data._id}`;
        const action = setSelectedEditProduct(data);
        const taggedAction = {
            ...action,
            meta: {
                ...(action.meta || {}),
                tabKey: tabKey,
            }
        }
        dispatch(taggedAction);
        dispatch(addTabIfNotExists("edit-product", tabKey, TABS_DATA, null, data.name));
    }
}

export const openDCLLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditDcl(data));
        dispatch(addTabIfNotExists("edit-dcl", generateTabKey(), TABS_DATA));
    }
}

export const openWorkPermitLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditWorkPermit(data));
        dispatch(addTabIfNotExists("edit-work-permit", generateTabKey(), TABS_DATA));
    }
}

export const openWorkMovementLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditWorkMovement(data));
        dispatch(addTabIfNotExists("edit-work-movement", generateTabKey(), TABS_DATA));
    }
}

export const openCashRegisterLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditCashRegisters(data));
        dispatch(addTabIfNotExists("edit-cash-registers", generateTabKey(), TABS_DATA));
    }
}

export const openBankAccountLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditBankAccount(data));
        dispatch(addTabIfNotExists("edit-bank-account", generateTabKey(), TABS_DATA));
    }
}

export const openPOSLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditPOS(data));
        dispatch(addTabIfNotExists("edit-pos", generateTabKey(), TABS_DATA));
    }
}

export const openChequeLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditCheque(data));
        dispatch(addTabIfNotExists("edit-cheque", generateTabKey(), TABS_DATA));
    }
}

export const openLoanLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditLoan(data));
        dispatch(addTabIfNotExists("edit-loan", generateTabKey(), TABS_DATA));
    }
}

export const openBasicTypeLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditBasicType(data));
        dispatch(addTabIfNotExists("edit-basic-types", generateTabKey(), TABS_DATA));
    }
}

export const openAdvancedTypeLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditAdvancedType(data));
        dispatch(addTabIfNotExists("edit-advanced-types", generateTabKey(), TABS_DATA));
    }
}

export const openAccountingAccountLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditAccountingAccount(data));
        dispatch(addTabIfNotExists("accounting-account-edit", generateTabKey(), TABS_DATA));
    }
}

export const openEmployeeLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditEmployee(data));
        dispatch(addTabIfNotExists("employee-edit", generateTabKey(), TABS_DATA));
    }
}

export const openPriceListLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditPriceList(data));
        dispatch(addTabIfNotExists("edit-price-list", generateTabKey(), TABS_DATA));
    }
}

export const openProductMovement = (dispatch, TABS_DATA, companyId, docId) => {
    try {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: companyId,
                docId: docId,
                section: "Product Movements",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(openProductMovementLocal(res.data.data, TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        });
    } catch (err) {
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση εγγραφής.");
    }
}

export const openProductMovementLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditProductMovements(data));
        dispatch(addTabIfNotExists("edit-product-movements", generateTabKey(), TABS_DATA));
    }
}

export const openClientMovementsReport = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("clients-movements", generateTabKey(), TABS_DATA));
    }
}

export const openSupplierMovementsReport = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("suppliers-movements", generateTabKey(), TABS_DATA));
    }
}

export const openPrimerPOSReport = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("reports-primer-pos", generateTabKey(), TABS_DATA));
    }
}

export const openCDRViewer = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("cdr-viewer", generateTabKey(), TABS_DATA));
    }
}

export const openCloud = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("cloud", generateTabKey(), TABS_DATA));
    }
}

export const openStart = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("start", generateTabKey(), TABS_DATA));
    }
}

export const openProductMovementsReport = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("product-movments-reports", generateTabKey(), TABS_DATA));
    }
}

export const openEditVisit = (data, TABS_DATA) => {
    // data should be {id: visitId}
    return (dispatch) => {
        dispatch(setEditVisit(data));
        dispatch(setEditVisitReload(true));
        dispatch(addTabIfNotExists("visit-edit", generateTabKey(), TABS_DATA));
    }
}

export const openFixedAssetMovementsReport = (dispatch, TABS_DATA) => {
    dispatch(addTabIfNotExists("report-fixed-asset-movements", generateTabKey(), TABS_DATA));
}

export const openNewVisit = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("visit-new", generateTabKey(), TABS_DATA));
    }
}

export const openNewSale = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("sales-new", generateTabKey(), TABS_DATA));
    }
}

export const openNewClient = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("new-client", generateTabKey(), TABS_DATA));
    }
}

export const openNewAccountingRecord = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("accounting-record-new", generateTabKey(), TABS_DATA));
    }
}

export const openPrescriptionSettings = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("prescription-settings", generateTabKey(), TABS_DATA));
    }
}

export const openPrescriptionHome = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("prescription-home", generateTabKey(), TABS_DATA));
    }
}

export const openUserSettings = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("user-settings", generateTabKey(), TABS_DATA));
    }
}

export const openEmployeeView = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("employee-view", generateTabKey(), TABS_DATA));
    }
}

export const openPrimerPaymentsReport = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("reports-primer-payments", generateTabKey(), TABS_DATA));
    }
}

export const openPrimerProviderContractsReport = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("report-client-provider-contracts", generateTabKey(), TABS_DATA));
    }
}

export const openWorkingProgram = (TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists("working-program", generateTabKey(), TABS_DATA));
    }
}

// Use it only if you want to open a unique tab
export const openTabByType = (tabType, TABS_DATA) => {
    return (dispatch) => {
        dispatch(addTabIfNotExists(tabType, generateTabKey(), TABS_DATA));
    }
}

export const openDocumentBySection = (documentId, companyId, section, TABS_DATA) => {
    return (dispatch) => {
        axios.get(process.env.REACT_APP_API_URL2 + "/company/get-document-by-id", {
            headers: {"Content-Type": "application/json"},
            params: {
                company: companyId,
                docId: documentId,
                section: section,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                if (section === "Product Movements") {
                    dispatch(openProductMovementLocal(res.data.data, TABS_DATA));
                } else if (section === "Sales") {
                    dispatch(openSaleLocal(res.data.data, TABS_DATA));
                } else if (section === "Client Movements") {
                    dispatch(openClientMovementLocal(res.data.data, TABS_DATA));
                } else if (section === "Client Payments") {
                    dispatch(openClientPaymentLocal(res.data.data, TABS_DATA));
                } else if (section === "Buys") {
                    dispatch(openBuyLocal(res.data.data, TABS_DATA));
                } else if (section === "Supplier Payments") {
                    dispatch(openSupplierPaymentLocal(res.data.data, TABS_DATA));
                } else if (section === "Supplier Movements") {
                    dispatch(openSupplierMovementLocal(res.data.data, TABS_DATA));
                } else if (section === "Accounting Records") {
                    dispatch(openAccountingRecordLocal(res.data.data, TABS_DATA));
                }
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
}

export const openSubmittedVatDeclarationLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        const monthNames = [
            "", "Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος",
            "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"
        ];
        const monthLabel = monthNames[Number(data.month)] || data.monthName || (data.month ? `${data.month}ος` : "");
        const tabKey = `view-submitted-vat-declaration/${data._id || `${data.year}-${data.month}`}`;
        const tabTitle = `Φ2 ${monthLabel} ${data.year}`;
        const action = setSelectedSubmittedVatDeclaration(data);
        const taggedAction = {
            ...action,
            meta: {
                ...(action.meta || {}),
                tabKey: tabKey,
            }
        };
        dispatch(taggedAction);
        dispatch(addTabIfNotExists("view-submitted-vat-declaration", tabKey, TABS_DATA, null, tabTitle));
    };
};

export const openSubmittedF4DeclarationLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        const monthNames = [
            "", "Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος",
            "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"
        ];
        const monthLabel = monthNames[Number(data.month)] || data.monthName || (data.month ? `${data.month}ος` : "");
        const tabKey = `view-submitted-f4-declaration/${data._id || `${data.year}-${data.month}`}`;
        const tabTitle = `Φ4 ${monthLabel} ${data.year}`;
        const action = setSelectedSubmittedF4Declaration(data);
        const taggedAction = {
            ...action,
            meta: {
                ...(action.meta || {}),
                tabKey: tabKey,
            }
        };

        dispatch(taggedAction);
        dispatch(addTabIfNotExists("view-submitted-f4-declaration", tabKey, TABS_DATA, null, tabTitle));
    };
};

export const openSubmittedF5DeclarationLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        const monthNames = [
            "", "Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος",
            "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"
        ];
        const monthLabel = monthNames[Number(data.month)] || data.monthName || (data.month ? `${data.month}ος` : "");
        const tabKey = `view-submitted-f5-declaration/${data._id || `${data.year}-${data.month}`}`;
        const tabTitle = `Φ5 ${monthLabel} ${data.year}`;
        const action = setSelectedSubmittedF5Declaration(data);
        const taggedAction = {
            ...action,
            meta: {
                ...(action.meta || {}),
                tabKey: tabKey,
            }
        };

        dispatch(taggedAction);
        dispatch(addTabIfNotExists("view-submitted-f5-declaration", tabKey, TABS_DATA, null, tabTitle));
    }
}

export const openDebtLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        const debtId = data._id || data.id;
        const tabKey = `view-debts/${debtId}`;

        let shortTaxType = data.taxType || "Οφειλή";
        if (shortTaxType.includes("ΦΠΑ")) shortTaxType = "ΦΠΑ";
        else if (shortTaxType.includes("ΕΙΣΟΔ")) shortTaxType = "Εισόδημα";
        else if (shortTaxType.includes("ΕΝΦΙΑ")) shortTaxType = "ΕΝΦΙΑ";
        else if (shortTaxType.length > 15) shortTaxType = shortTaxType.substring(0, 15) + "...";

        const tabTitle = `${shortTaxType} (${data.taxYear || ""})`;
        const action = setSelectedUnregulatedDebt(data);
        const taggedAction = {
            ...action,
            meta: {
                ...(action.meta || {}),
                tabKey: tabKey,
            }
        };

        dispatch(taggedAction);
        dispatch(addTabIfNotExists("view-debts", tabKey, TABS_DATA, null, tabTitle));
    };
};

export const openCardLocal = (data, TABS_DATA) => {
    return (dispatch) => {
        dispatch(setEditCard(data));
        dispatch(addTabIfNotExists("cards-edit", generateTabKey(), TABS_DATA));
    }
}
